import React from 'react';
import { Row, Col } from 'antd';
// import img from '../../assets/hands-creative-grass-moss.jpg';
import bg from '../../assets/circles-ballet.png';

const intl = {
  headline: {
    'en': <span>WHY WE DO IT<br/><div style={{ color: '#8c8c8c', fontSize: '14px', textTransform: 'none', lineHeight: '12px', letterSpacing: '0px' }}>It's all about continuous improvement</div></span>,
    'dk': <span>HVORFOR VI GØR DET<br/><div style={{ color: '#8c8c8c', fontSize: '14px', textTransform: 'none', lineHeight: '12px', letterSpacing: '0px' }}>Det hele handler om kontinuerlig udvikling</div></span>
  },
  body: {
    'en': <div>
      Organizational development has only one purpose: to improve the organizational ability to deliver results. There are multiple ways of pursuing this objective. We believe that leaders must insist on continuous improvement: of employees, of colleagues and, not least, of themselves.
      <br/><br/>
      Organizations have a clear objective to deliver on their primary task to the best of their ability with the available resources. That requires attentive adaptation in a constantly changing world. It means developing skills, competencies and people, and nurturing an environment that enables all of that.
      <br/><br/>
      For organizations there is a natural tension between conditions and circumstances. While conditions are imposed constraints, circumstances represent potential opportunities.
      <br/><br/>
      We assist organizations in reaching their long-term goals through the development of a sustainable, healthy and results-oriented organizational culture.
    </div>,
    'dk': <div>
      Organisationsudvikling har ét formål – at forbedre organisationens evne til at levere resultater. Der er mange måder af forfølge det mål på. Vi mener at ledere generelt skal insistere på kontinuerlig forbedring. Af medarbejdere, af deres kollegaer og ikke mindst dem selv. Organisationen har et formål; at løse sin opgave bedst muligt med de ressourcer, der er til rådighed. Det kræver opmærksom navigering i en verden der konstant ændrer sig; det kræver tilpasning af kompetencer, udvikling af mennesker og et miljø, der danner ramme for at dette kan ske.
      <br/><br/>
      For organisationer er der et forhold mellem vilkår og omstændigheder. Vilkår er ydre begrænsninger, mens omstændigheder er konstruktive og mulighedsskabende, og de stiller krav til organisationen om at udnytte disse og udvikle sig.
      <br/><br/>
      Vi hjælper organisationer med at nå deres langsigtede mål gennem udvikling af en bæredygtig, sund og resultatfokuseret kultur.
    </div>
  }
}

function ImageBlock2({ language, maxHeight }) {
  return (
    <Row style={{ backgroundColor: '#fff', color: '#000', paddingTop: '50px' }}>
      <Col sm={24} md={{ span: 16, offset: 4 }}>
        <Row>

          <Col sm={24} md={{ span: 12 }} style={{ position: 'relative', height: '100%' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'left',
                height: '500px',
                textAlign: 'left',
              }}
            >
              <div className="blog_block_content">
                <h2
                  style={{
                    fontSize: '20px',
                    letterSpacing: '1px',
                    lineHeight: '25px',
                    marginBottom: '15px',
                    textTransform: 'uppercase',
                    color: '#1abc9c'
                  }}
                >
                  {intl.headline[language]}
                </h2>
                <p
                  style={{
                    color: '#8c8c8c',
                    marginBottom: '25px',
                    maxHeight: maxHeight || '350px',
                    fontSize: '14px',
                    // whiteSpace: 'nowrap',
                    // overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {intl.body[language]}
                </p>
              </div>
            </div>
          </Col>
          <Col
            sm={24}
            md={{ span: 12 }}
            style={{
              display: 'flex',
              alignItems: 'center',
              height: '500px',
              justifyContent: 'center',
              paddingLeft: '50px',
            }}
          >
            <div
              style={{
                height: '100%',
                width: '100%',
                border: '10px solid transparent',
                background: `url(${bg}) no-repeat center center`,
                backgroundSize: 'contain',
              }}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default ImageBlock2;

ImageBlock2.defaultProps = {
  headline: 'Headline about something?',
  body: 'iLead is the blalbalbl balbl ab blablalbalb labla',
  img: bg,
  displayReadMore: false,
};



// WEBPACK FOOTER //
// ./src/pages/Methodology/ImageBlock2.js